import { Option } from '@focaldata/cin-ui-components'
import { FieldworkAudienceType } from '../data/model/fieldwork'

export enum PanelSupplier {
  CINT = 'cint',
  PROLIFIC = 'prolific',
  CUSTOM = 'fd',
  PURESPECTRUM = 'purespectrum',
  CINT_EXCHANGE = 'cintexchange'
}

export const panelOptions: Option[] = [
  { id: PanelSupplier.CINT, name: 'Cint', value: PanelSupplier.CINT },
  {
    id: PanelSupplier.PROLIFIC,
    name: 'Prolific',
    value: PanelSupplier.PROLIFIC
  },
  { id: PanelSupplier.CUSTOM, name: 'Custom', value: PanelSupplier.CUSTOM },
  {
    id: PanelSupplier.PURESPECTRUM,
    name: 'PureSpectrum',
    value: PanelSupplier.PURESPECTRUM
  },
  {
    id: PanelSupplier.CINT_EXCHANGE,
    name: 'Cint Exchange',
    value: PanelSupplier.CINT_EXCHANGE
  }
]

// Markets are created on PureSpectrum and can switch to Custom (own audience /
// universal link). Filtered from panelOptions so the names — also sent as the
// audience description — can't drift from the single-survey picker.
export const multiMarketPanelOptions: Option[] = panelOptions.filter(
  ({ value }) =>
    value === PanelSupplier.PURESPECTRUM || value === PanelSupplier.CUSTOM
)

const audienceTypeToPanel: Record<string, PanelSupplier> = {
  CintAudience: PanelSupplier.CINT,
  ProlificAudience: PanelSupplier.PROLIFIC,
  PureSpectrumAudience: PanelSupplier.PURESPECTRUM,
  CustomAudience: PanelSupplier.CUSTOM,
  CintExchangeAudience: PanelSupplier.CINT_EXCHANGE
}

export const convertAudienceType = (
  value: FieldworkAudienceType | undefined
): PanelSupplier => {
  if (!value) {
    throw new Error('Audience is undefined')
  }
  const panel = audienceTypeToPanel[value]
  return panel
}
